"use server";

import { createAdminClient } from "@/lib/supabase/admin";
import { getSession, isStaffRole } from "@/lib/auth/session";
import { pendingPublishingQueue } from "@/lib/publishing/queue-data";

/**
 * How many items across every company are waiting on the signed-in user.
 *
 * Fetched on demand by the top bar rather than server-rendered in the root
 * layout: it is two queries, and paying them on every page load to badge a
 * control that only shows on agency pages is the wrong trade. The per-company
 * count still comes from the client layout, which already loads it.
 *
 * pendingPublishingQueue scopes to the viewer's own pending approvals, so the
 * count is theirs, not the agency's backlog.
 */
export async function pendingApprovalsCountAction(): Promise<number> {
  const session = await getSession();
  if (!session || !isStaffRole(session.profile.role)) return 0;
  try {
    const rows = await pendingPublishingQueue(createAdminClient(), session.user.id);
    return rows.length;
  } catch (err) {
    console.error("[approvals count] failed:", err);
    return 0;
  }
}
